export const FLAG = 'F';
export const SEEN = 'S';
export const UNSEEN = 'U';
